import BackArrow from "@assets/svg/BackArrow";
import RightArrow from "@assets/svg/RightArrow";
import Text from "@components/CustomText";
import { GULLAK_EVENTS } from "@constants/analyticsEventsCT";
import t from "@constants/localization";
import analytics from "@services/analytics";
import { getPassbookTransactions, gullakCms } from "@services/api";
import { scale } from "@utils/scale";
import { format } from "date-fns";
import React, { useEffect, useRef, useState } from "react";
import {
  Dimensions,
  Pressable,
  StyleSheet,
  TouchableOpacity,
  View,
} from "react-native";
import Animated, {
  interpolate,
  interpolateColor,
  useAnimatedScrollHandler,
  useAnimatedStyle,
  useSharedValue,
} from "react-native-reanimated";
import { useDispatch, useSelector } from "react-redux";
import LeaderWalletStats from "../Wallet/LeaderWalletStats";
import TnC from "../Wallet/TnC";

const PATH = "screens/GullakMoney";

// const { diffClamp, interpolate, interpolateColors } = Animated;
const { width: screenWidth } = Dimensions.get("screen");

const Screen = ({ navigation, route }) => {
  const {
    walletSummary: { totals = {} },
    currentFilter = {},
    terms,
  } = useSelector((state) => state.wallet);
  const [fetchingTransactions, setFetchingTransactions] = useState(false);
  const [transactions, setTransactions] = useState([]);
  const { total_sales = 0, total_commission = 0, balance = 0 } = totals || {};
  const dispatch = useDispatch();
  const tnCRef = useRef();
  const [general, setGeneral] = useState({ loading: true });
  useEffect(() => {
    gullakCms()
      .then((res) => {
        setGeneral({ ...res.data, loading: false });
      })
      .catch(() => {});
    fetchTransactions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getFormatedDate = (date) => {
    return format(new Date(date), "yyyy-MM-dd");
  };

  const fetchTransactions = () => {
    let fromDate = new Date();
    fromDate.setMonth(fromDate.getMonth() - 3);
    fromDate = format(fromDate, "yyyy-MM-dd");
    const toDate = format(new Date(), "yyyy-MM-dd");
    const dates = {
      to: getFormatedDate(toDate),
      from: getFormatedDate(fromDate),
    };
    setFetchingTransactions(true);
    getPassbookTransactions({
      ...dates,
      limit: 1,
      offset: 0,
    })
      .then(({ data }) => {
        setTransactions(manipulatedPassbookItems(data.data));
        setFetchingTransactions(false);
      })
      .catch((e) => {
        console.log(e);
        setFetchingTransactions(false);
      });
  };

  const manipulatedPassbookItems = (data) => {
    return data.map((passbookItem) => {
      let itemProps = {};
      if (passbookItem.type === "commission-credit") {
        itemProps = {
          typeHi: passbookItem.typeHi,
          id: passbookItem.type,
          type: passbookItem.type,
          orderCommissionView: true,
          orderCommissionData: {
            username: passbookItem.customer_name,
            orderNumber: passbookItem.order_id,
            date: passbookItem.date,
            status: passbookItem.statusHi,
            statusKey: passbookItem.status,
          },
          secondaryStats: true,
          secondaryStatsData: Array.isArray(passbookItem.data)
            ? passbookItem.data.map((s) => ({
                title: s.label,
                value: s.value !== null ? `₹${s.value}` : "",
              }))
            : [],
        };
      } else if (
        passbookItem.type !== "commission-credit" &&
        passbookItem.type !== "withdrawal"
      ) {
        itemProps = {
          typeHi: passbookItem.typeHi ?? "",
          id: passbookItem.type,
          type: passbookItem.type,
          otherCommissionsView: true,
          otherCommissionsData: {
            title: passbookItem.reason,
            commission: passbookItem.amount,
            date: passbookItem.date,
            status: passbookItem.statusHi,
            statusKey: passbookItem.status,
          },
        };
      } else if (passbookItem.type === "withdrawal") {
        itemProps = {
          typeHi: passbookItem.typeHi,
          id: passbookItem.type,
          type: passbookItem.type,
          title: passbookItem.reason,
          value: passbookItem.amount,
          date: passbookItem.date,
          status: passbookItem.statusHi,
          statusKey: passbookItem.status,
        };
      }
      return itemProps;
    });
  };

  const scrollY = useSharedValue(0);

  const scrollHandler = useAnimatedScrollHandler({
    onScroll: (event) => {
      scrollY.value = event.contentOffset.y;
    },
  });

  const animatedStyleOpacity1 = useAnimatedStyle(() => {
    const opacity = interpolate(
      scrollY.value,
      [0, (250 / 360) * screenWidth - 35, (250 / 360) * screenWidth - 35],
      [0, 1, 1],
    );
    return {
      opacity,
    };
  });

  const animatedStyleOpacity2 = useAnimatedStyle(() => {
    const opacity = interpolate(
      scrollY.value,
      [0, (250 / 360) * screenWidth - 70, (250 / 360) * screenWidth - 70],
      [1, 0, 0],
    );
    return {
      opacity,
    };
  });

  const animatedStyleOpacity3 = useAnimatedStyle(() => {
    const opacity = interpolate(
      scrollY.value,
      [0, ((250 / 360) * screenWidth - 70) / 2, (250 / 360) * screenWidth - 70],
      [1, 0.5, 0],
    );
    return {
      opacity,
    };
  });

  return (
    <View style={{ flex: 1, backgroundColor: "#F7F7F7" }}>
      <Animated.View
        style={[
          {
            height: 70,
            paddingBottom: 15,
            position: "absolute",
            zIndex: 5,
            backgroundColor: interpolateColor(
              scrollY.value,
              [
                0,
                (240 / 360) * screenWidth - 70,
                (240 / 360) * screenWidth - 70,
              ],
              ["white", "white", "white"],
            ),
            width: screenWidth,
          },
          animatedStyleOpacity1,
        ]}
      >
        <View
          style={{
            flexDirection: "row",
            paddingHorizontal: 15,
            marginTop: "auto",
            alignItems: "center",
          }}
        >
          <BackArrow color="black" />
          <Animated.View
            style={[
              {
                marginLeft: 20,
              },
            ]}
          >
            <Text
              style={{
                fontSize: 18,
                lineHeight: 28,
                fontFamily: "NotoSansDevanagari-Bold",
              }}
            >
              {t(`${PATH}/walletMoney`)}
            </Text>
          </Animated.View>
        </View>
      </Animated.View>

      <Animated.View
        style={[
          {
            height: 70,
            paddingBottom: 15,
            position: "absolute",
            zIndex: 5,
            backgroundColor: "transparent",
            width: screenWidth,
          },
          animatedStyleOpacity2,
        ]}
      >
        <View
          style={{
            flexDirection: "row",
            paddingHorizontal: 15,
            marginTop: "auto",
            alignItems: "center",
          }}
        >
          <TouchableOpacity
            testID="gm-back"
            onPress={() => navigation.goBack()}
          >
            <BackArrow color="black" />
          </TouchableOpacity>
          <Animated.View
            style={{
              marginLeft: 20,
            }}
          >
            <Text bold style={{ fontSize: 18, lineHeight: 28 }}>
              {" "}
            </Text>
          </Animated.View>
        </View>
      </Animated.View>
      {!general.loading && (
        <Animated.Image
          resizeMode="contain"
          source={{
            uri: general.backgroundImg,
          }}
          style={[
            {
              width: screenWidth,
              height: undefined,
              aspectRatio: general.aspectRatio ?? 360 / 240,
              position: "absolute",
            },
            animatedStyleOpacity3,
          ]}
        />
      )}
      <Animated.ScrollView
        onScroll={scrollHandler}
        contentContainerStyle={{
          paddingTop: (250 / 360) * screenWidth,
        }}
      >
        <View
          style={{
            backgroundColor: "#f7ffee",
            paddingHorizontal: 12,
            paddingVertical: 20,
          }}
        >
          {!general.loading && (
            <View
              style={{
                alignItems: "center",
              }}
            >
              <Text
                variant="heading_24"
                // style={styles.headerTitle}
              >
                {general.title}
              </Text>
              <Text variant="body_text_1" style={styles.subheaderTitle}>
                {general.subTitle}
              </Text>
            </View>
          )}
          <View
            style={{
              flexDirection: "row",
              backgroundColor: "#E7FFCC",
              paddingHorizontal: 16,
              paddingVertical: 18,
              borderRadius: 6,
              borderWidth: 1,
              borderColor: "rgba(0, 0, 0, 0.1)",
              marginTop: 20,
              marginBottom: 8,
            }}
          >
            <View style={{ flex: 1 }}>
              <Text
                variant="body_text_1"
                style={{
                  color: "rgba(0, 0, 0, 0.86)",
                }}
              >
                {t("gullak/totalFund")}
              </Text>
              <Text
                variant="heading_24"
                style={{
                  color: "rgba(0, 0, 0, 0.86)",
                }}
              >
                {`${t("common/rupee")} ${balance} `}
              </Text>
            </View>
            <Pressable
              testID="gm-withdraw"
              onPress={() => {
                analytics.trackEvent(GULLAK_EVENTS.PAISE_NIKALE);
                navigation.navigate("WithDrawGullakMoney");
              }}
            >
              <View
                style={{
                  flexDirection: "row",
                  padding: 5,
                }}
              >
                <Text
                  variant="body_text_2"
                  style={{
                    color: "rgba(0, 0, 0, 0.86)",
                    marginRight: 7,
                  }}
                >
                  {t("gullak/withdrawMoney")}
                </Text>
                <View style={{ marginTop: 4 }}>
                  <RightArrow />
                </View>
              </View>
            </Pressable>
          </View>
        </View>
        <LeaderWalletStats />
        <View
          style={{
            padding: scale(15),
            paddingVertical: scale(30),
            backgroundColor: "#f7ffee",
          }}
        >
          <Pressable
            testID="gm-tnc"
            onPress={() => tnCRef.current.openModal()}
            style={{
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: 6,
              borderWidth: 1,
              borderColor: "rgba(0, 0, 0, 0.1)",
              paddingVertical: 12,
              paddingHorizontal: 16,
              marginTop: 8,
              backgroundColor: "white",
            }}
          >
            <Text
              variant="body_text_2"
              style={{
                // fontSize: 14,
                // lineHeight: 21,
                color: "rgba(0, 0, 0, 0.86)",
                marginRight: 6,
                flex: 1,
              }}
            >
              {t(`${PATH}/TnC`)}
            </Text>
            <RightArrow />
          </Pressable>
        </View>
      </Animated.ScrollView>
      <TnC ref={tnCRef} terms={terms} />
    </View>
  );
};

export default Screen;

const styles = StyleSheet.create({
  subheaderTitle: {
    // fontSize: 16,
    // lineHeight: 24,
    color: "rgba(0, 0, 0, 0.56)",
  },
});
